const apiUrl = 'https://api.takkt.io';
// const apiUrl = 'http://localhost:4000';

export { apiUrl };
